// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"883b764c","453":"921bb3c8"}[chunkId] + ".chunk.js";
};